import React, { ReactNode, useEffect, useState } from "react"
import axios from "../utils/axios";

let cache: { [key: string]: boolean } = {};

const cachingFunction = (flagName: string, callback: (input: boolean) => any) => {
    if (flagName in cache) {
        return;
    }
    
    axios.instance.get("api/frontendFeatureFlag", { params: { flagName } })
        .then((response) => {
            cache[flagName] = response.data;
            callback(response.data);
        })
        .catch((error) => {
            callback(false);
        });
}

export const FeatureFlag = ({ children, flagName }: { children: ReactNode, flagName: string }) => {
    const [isEnabled, setEnabled] = useState<boolean>(cache[flagName]);

    useEffect(() => {
        cachingFunction(flagName, setEnabled);
    }, [flagName]);

    return <>{isEnabled && children}</>
}

/**
 * This is a helper function for testing
 */
export const clearCache = () => {
    cache = {};
}